'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { routes } from './routes';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    router.replace(routes.jobs);
  }, [router]);

  return null;
}
